/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createAcos } from '../../factoriesAny.js';
export var acosDependencies = {
  ComplexDependencies: ComplexDependencies,
  typedDependencies: typedDependencies,
  createAcos: createAcos
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesAcos.generated.js
// module id = 1336
// module chunks = 0